import { useEffect } from 'react';

/**
 * Sidetittel «Innboks · Følget · Innspel»: det leietakeren ser i fanelisten med ti faner
 * åpne. Tomme deler utelates, så tittelen er «Innboks · Innspel» til /v1/admin/me har svart
 * og «Logg inn · Innspel» før innlogging.
 */
export function useSidetittel(...deler: Array<string | undefined>) {
  const tittel = [...deler.filter((d): d is string => Boolean(d)), 'Innspel'].join(' · ');
  useEffect(() => {
    document.title = tittel;
  }, [tittel]);
}
